import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { ProtelModel } from "projects/sepidz-web-framework/src/lib/models/Protel.model";
import { LocalStoreManager, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { take, takeUntil } from "rxjs/operators";
import { LocalSetting } from "src/app/frontoffice/local-setting/local-setting-model";
import { SaleMethodBranchPaymentMethod } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { DialogType } from "../../../../../../../projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "../../../../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { PaymentMethodType } from "../../../../financial/model/payment-method.enum";
import { FastAccessEnum } from "../../../model/fastaccessenum";
import { Invoice, InvoiceCommand, InvoiceStatus, PosPaymentResponse } from "../../../model/invoice.model";
import { PaymentEnum } from "../../../model/payment.enum";
import { PaymentMethodLookUp } from "../../../model/payment.lookup";
import { PaymentMethodEnum } from "../../../model/paymentmethod.enum";
import { ReceiptPaymentModel, ReceiptPaymentTypeEnum } from "../../../model/receiptpayment.model";
import { OrderService } from "../../../order.service";
import { InvoiceActionService } from "../../../providers/invoiceaction.service";

@Component({
  selector: "order-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentComponent extends BaseFormComponent<ReceiptPaymentModel> {
  order: OrderService;
  receiptPayments: ReceiptPaymentModel[] = [];
  PaymentMethod: PaymentMethodLookUp[];
  ReceiptPaymentType: Lookup[];
  hasDebitTransfer: boolean;
  hasCreditTransfer: boolean;
  hasTipTransfer: boolean;
  PaymentEnum: typeof PaymentEnum = PaymentEnum;
  rowState: typeof RowState = RowState;
  deactivateSave: boolean;
  deactivateClose: boolean = false;
  isClearWithoutPrint: boolean = false;
  deactiveForm: boolean;
  isFirst: boolean;
  isFinished: number = 0;
  shouldUpdateInvoice: boolean = false;
  invoiceAction: InvoiceActionService;
  defaultPayment: SaleMethodBranchPaymentMethod;
  isDeposit = false;
  action: InvoiceCommand;
  nonBalanceChangedManualy: boolean;
  protel: ProtelModel;
  closeDialog: boolean = false;
  paymentMethodId: number;
  originalInvoice: any;
  savePaymentClicked: boolean = false;
  lSetting: LocalSetting[] = [];
  hasAutorecord: boolean;
  constructor(
    private lookupservice: LookupService,
    private splashFormService: SplashFormService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private storage: LocalStoreManager
  ) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.invoiceAction.ngOnInit();
    this.apiName = "ReceiptPayment";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Payment");
    this.FillData();
    if (this.order.invoice.HasPaymentLink && this.order.saleMethodBranch?.HasDeposit)
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PayInvoiceByLink"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Attention"),
        DialogType.confirm,
        () => {},
        () => {
          this.order.selectedFastAccess = FastAccessEnum.PaymentLink;
          this.order._opened = true;
          this.close();
        }
      );
  }

  ngOnDestroy(): void {
    if (this.invoiceAction.saveEndSubscription) {
      this.invoiceAction.saveEndSubscription.unsubscribe();
      this.invoiceAction.saveEndSubscription = null;
    }
  }

  FillData() {
    this.result = false;
    this.defaultPayment = this.order.saleMethodBranch.PaymentMethods.find((s) => s.IsDefault);
    if (this.order.invoice.StatusCode === InvoiceStatus.Completed) this.deactiveForm = true;
    this.deactivateSave = true;
    const newGroup: any = {};
    newGroup["remaining"] = new UntypedFormControl(undefined);
    newGroup["tip"] = new UntypedFormControl(undefined);
    newGroup["debit"] = new UntypedFormControl(undefined);
    newGroup["credit"] = new UntypedFormControl(undefined);
    this.formGroup = new UntypedFormGroup(newGroup);
    this.formGroup.controls[`remaining`].disable();
    this.formGroup.controls[`tip`].setValue(this.order.invoice.Tip);
    this.formGroup.controls[`debit`].setValue(this.order.invoice.Debit);
    this.formGroup.controls[`credit`].setValue(this.order.invoice.Credit);

    if (this.order.invoice.Customer?.HasCredit) {
      this.hasDebitTransfer = true;
    }
    this.checkValidation();
    this.isSaved = false;
    this.receiptPayments = null;
    this.receiptPayments = JSON.parse(JSON.stringify(this.order.invoice.ReceiptPayments));
    this.getPaymentMethod();
    this.setValue("NonBalance", false);
  }
  //اضافه کردن به فرم گروپ
  addGroup() {
    if ((this.order.invoice.Customer && this.order.invoice.Customer && this.order.invoice.Customer.AutomaticDebtor) || this.order.invoice.Debit > 0) {
      if (this.order.invoice.State === RowState.Modify && this.order.invoice.ReceiptPayments?.length <= 0)
        this.order.invoice.Debit = this.order.invoice.PayableTotal;
      else this.order.invoice.Debit = this.order.invoice.Debit > 0 ? this.order.invoice.Debit : this.order.invoice.PayableTotal;
      this.formGroup.controls[`debit`].setValue(this.order.invoice.Debit);
    }
    if (this.order.invoice.Credit > 0) this.formGroup.controls[`credit`].setValue(this.order.invoice.Credit);
    const defaultReceiptPaymentTypeId = this.ReceiptPaymentType.find((f) => f.Code === 2).Id;
    if (!this.receiptPayments || (this.receiptPayments.length <= 0 && this.order.invoice.PayableTotal > 0)) {
      const index = Math.floor(Math.random() * 10000000);
      const ReceiptModel = new ReceiptPaymentModel();
      ReceiptModel.State = RowState.New;
      ReceiptModel.Index = index;
      ReceiptModel.ReceiptPaymentType = JSON.parse(JSON.stringify(this.ReceiptPaymentType));
      ReceiptModel.PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
      this.receiptPayments.push(ReceiptModel);
      const PaymentMethodId = this.defaultPayment
        ? this.PaymentMethod.find((f) => f.Id === this.defaultPayment.PaymentMethodId).Id
        : this.PaymentMethod[0].Id;
      this.setValue(`PaymentMethodId${index}`, PaymentMethodId, true);
      this.setValue(`ReceiptPaymentTypeId${index}`, defaultReceiptPaymentTypeId, true);
      this.receiptPayments[0].Amount =
        this.order.invoice?.Customer?.AutomaticDebtor || this.order.invoice.Debit > 0
          ? this.order.invoice.PayableTotal - this.order.invoice.Debit
          : this.order.invoice.PayableTotal;
      this.receiptPayments[0].Amount =
        this.order.invoice.Credit > 0 ? this.order.invoice.PayableTotal - this.order.invoice.Credit : this.receiptPayments[0].Amount;
      this.setValue(`receivedmoney${index}`, this.receiptPayments[0].Amount, true);
      this.receiptPayments[0].PaymentMethodId = PaymentMethodId;
      this.receiptPayments[0].ReceiptPaymentTypeId = defaultReceiptPaymentTypeId;
      if (this.defaultPayment)
        this.receiptPayments[0].ShowPospayment =
          this.PaymentMethod.find((f) => f.Id === this.defaultPayment.PaymentMethodId)?.PaymentMethodCode === 2;
      else this.receiptPayments[0].ShowPospayment = this.PaymentMethod[0].PaymentMethodCode === 2;
      if (this.receiptPayments[0].ShowPospayment) this.deactivateSave = true;
    } else {
      if (this.receiptPayments && this.receiptPayments.length > 0 && !this.formGroup) {
        for (let i = 0; i < this.receiptPayments.length; i++) {
          const index = Math.floor(Math.random() * 10000000);
          this.receiptPayments[i].Index = index;
          this.setValue(`PaymentMethodId${index}`, this.receiptPayments[i].PaymentMethodId, true);
          this.setValue(`ReceiptPaymentTypeId${index}`, defaultReceiptPaymentTypeId, true);
          this.setValue(`receivedmoney${index}`, this.receiptPayments[i].Amount, true);
          if (this.order.invoice.StatusCode !== InvoiceStatus.New) this.receiptPayments[i].State = RowState.Modify;
          if (this.receiptPayments[i].PaymentMethod.length === 1) this.setValue(`PaymentMethodId${index}`, this.PaymentMethod[0].Id, true);
        }
      } else {
        if (this.receiptPayments && this.receiptPayments.length > 0) {
          const index = this.receiptPayments.length - 1;
          const i = Math.floor(Math.random() * 10000000);
          this.setValue(`PaymentMethodId${i}`, this.receiptPayments[index].PaymentMethodId, true);
          this.setValue(`ReceiptPaymentTypeId${i}`, defaultReceiptPaymentTypeId, true);
          this.setValue(`receivedmoney${i}`, this.receiptPayments[index].Amount, true);
          this.receiptPayments[index].Id = 0;
          this.receiptPayments[index].State = RowState.New;
          this.receiptPayments[index].Index = i;
          this.deactiveForm = false;
          if (this.receiptPayments[index].PaymentMethod.length === 1) this.setValue(`PaymentMethodId${i}`, this.PaymentMethod[0].Id, true);
          this.setValue(`ReceiptPaymentTypeId${i}`, defaultReceiptPaymentTypeId, true);
        }
      }
    }
    this.checkValidation();
    this.calculate(true);
  }

  getReceiptPaymentTypeLookUp() {
    this.lookupservice
      .getLookupbyCategory("SALE", "ReceiptPaymentType")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        this.ReceiptPaymentType = data.sort((a, b) => a.Code - b.Code);
        if (this.receiptPayments && this.receiptPayments.length > 0) {
          for (let i = 0; i < this.receiptPayments.length; i++) {
            const index = Math.floor(Math.random() * 10000000);
            this.receiptPayments[i].ReceiptPaymentType = JSON.parse(JSON.stringify(this.ReceiptPaymentType));
            this.receiptPayments[i].PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
            this.receiptPayments[i].Index = index;
            if (this.order.invoice.ReceiptPayments && this.order.invoice.ReceiptPayments.length > 0) {
              this.setValue(`PaymentMethodId${index}`, this.receiptPayments[i].PaymentMethodId, true);
              this.setValue(`ReceiptPaymentTypeId${index}`, this.receiptPayments[i].ReceiptPaymentTypeId, true);
              this.setValue(`receivedmoney${index}`, this.receiptPayments[i].Amount, true);
              this.formGroup.controls[`PaymentMethodId${index}`].disable();
              this.formGroup.controls[`receivedmoney${index}`].disable();
              this.formGroup.controls[`ReceiptPaymentTypeId${index}`].disable();
              this.deactivateSave = true;
            }
          }
          /// اضافه کردن اتوماتیک یک رکورد در صورت اختلاف قیمت کل با با قیمانده در مود ویرایش
          if (this.order.invoice?.OriginalValue?.PayableTotal !== this.order.invoice.PayableTotal) {
            const receipt = new ReceiptPaymentModel();
            const i = Math.floor(Math.random() * 10000000);
            receipt.ReceiptPaymentType = JSON.parse(JSON.stringify(this.ReceiptPaymentType));
            receipt.PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
            receipt.Index = i;
            receipt.Id = 0;
            let PaymentMethodId = this.defaultPayment
              ? this.PaymentMethod.find((f) => f.Id === this.defaultPayment.PaymentMethodId).Id
              : this.PaymentMethod[0].Id;
            this.setValue(`PaymentMethodId${i}`, PaymentMethodId, true);
            this.setValue(`ReceiptPaymentTypeId${i}`, receipt.ReceiptPaymentTypeId, true);
            this.setValue(`receivedmoney${i}`, this.order.invoice?.OriginalValue?.PayableTotal - this.order.invoice?.PayableTotal, true);
            if (this.order.invoice?.OriginalValue?.PayableTotal > this.order.invoice.PayableTotal) {
              this.setValue(`ReceiptPaymentTypeId${i}`, this.ReceiptPaymentType.find((f) => f.Code === ReceiptPaymentTypeEnum.Payment).Id, true);
              this.setValue(`receivedmoney${i}`, this.order.invoice?.OriginalValue?.PayableTotal - this.order.invoice.PayableTotal, true);
              PaymentMethodId = this.PaymentMethod[0].Id;
              this.setValue(`PaymentMethodId${i}`, PaymentMethodId, true);
            } else {
              this.setValue(`ReceiptPaymentTypeId${i}`, this.ReceiptPaymentType.find((f) => f.Code === ReceiptPaymentTypeEnum.Receipt).Id, true);
              this.setValue(`receivedmoney${i}`, this.order.invoice.PayableTotal - this.order.invoice?.OriginalValue?.PayableTotal, true);
            }
            receipt.State = RowState.New;
            const paymentMethodCode = receipt.PaymentMethod.find((f) => f.Id == PaymentMethodId).PaymentMethodCode;
            if (paymentMethodCode === PaymentMethodEnum.Pos || paymentMethodCode === PaymentMethodEnum.TabletPos) receipt.ShowPospayment = true;
            else receipt.ShowPospayment = false;
            this.receiptPayments[this.receiptPayments.length] = receipt;
            this.deactivateSave = false;
          }
        }

        if (!this.receiptPayments || this.receiptPayments.length <= 0) this.addGroup();
        else this.calculate(true);
        if (this.formGroup.controls[`remaining`].value < 0) this.addPayment();
        this.splashFormService.closeLoading();
      });
  }
  // برای بایند کردن نام در سند html

  // گرفتن نوع پرداخت
  getPaymentMethod() {
    const hasForbidden: SaleMethodBranchPaymentMethod[] = this.order.saleMethodBranch.PaymentMethods.filter((f) => !f.IsDefault);
    const paymentMethodTypeLookup = this.order.paymentMethodTypeLookup.filter(
      (x) => x.PaymentMethodCode !== PaymentMethodType.Internet && x.PaymentMethodCode !== PaymentMethodType.Check
    );
    if (hasForbidden && hasForbidden.length > 0)
      this.PaymentMethod = paymentMethodTypeLookup
        .filter((f) => !hasForbidden.some((s) => s.PaymentMethodId === f.Id))
        .sort((a, b) => a.PaymentMethodCode - b.PaymentMethodCode);
    else this.PaymentMethod = paymentMethodTypeLookup.sort((a, b) => a.PaymentMethodCode - b.PaymentMethodCode);
    //گرفتن لوک اپ
    this.getReceiptPaymentTypeLookUp();
  }
  addPayment() {
    // this.shouldUpdateInvoice = false;
    const posPaymentMethodIds = this.PaymentMethod.filter((c) => c.PaymentMethodCode === PaymentMethodType.Pos).map((e) => e.Id);
    const ReceiptModel = new ReceiptPaymentModel();
    ReceiptModel.ReceiptPaymentType = JSON.parse(JSON.stringify(this.ReceiptPaymentType));
    if (this.formGroup.controls["remaining"].value < 0 && this.receiptPayments.some((c) => posPaymentMethodIds.includes(c.PaymentMethodId))) {
      this.shouldUpdateInvoice = true;
      ReceiptModel.State = RowState.New;
      ReceiptModel.PaymentMethodId = this.PaymentMethod.find((c) => c.PaymentMethodCode === PaymentMethodType.Cash).Id;
    }
    // if (this.formGroup.controls["remaining"].value < 0 && this.receiptPayments.some((c) => posPaymentMethodIds.includes(c.PaymentMethodId))) {
    //   this.shouldUpdateInvoice = true;
    //   const index = Math.floor(Math.random() * 10000000);
    //   ReceiptModel.Index = index;
    //   ReceiptModel.State = RowState.New;
    //   ReceiptModel.PaymentMethodId = this.PaymentMethod.find((c) => c.PaymentMethodCode === PaymentMethodType.Cash).Id;
    //   ReceiptModel["IsCashAfterPos"] = true;
    // }
    ReceiptModel.PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
    if (this.formGroup.controls[`remaining`].value < 0) ReceiptModel.Amount = -this.formGroup.controls[`remaining`].value;
    this.receiptPayments.push(ReceiptModel);
    this.addGroup();
  }
  removePayment(index: number) {
    const findIndex = this.receiptPayments.findIndex((f) => f.Index === index);
    this.receiptPayments.splice(findIndex, 1);
    this.formGroup.removeControl(`PaymentMethodId${index}`);
    this.formGroup.removeControl(`ReceiptPaymentTypeId${index}`);
    this.formGroup.removeControl(`receivedmoney${index}`);
    this.calculate();
  }
  cancel() {
    this.closeModal();
  }
  isConfirm(): boolean {
    return true;
  }
  isValid(): boolean {
    if (this.formGroup.controls[`remaining`].value > 0 && !this.formGroup.controls["NonBalance"].value) {
      this.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ResidualValueGreaterThanZero"));
      this.splashFormService.closeLoading();
      return false;
    }

    this.deactivateSave = false;
    return true;
  }
  // پر کردن فاکتور قبل از زخیره دیتا
  beforeSaveData() {
    let depositAmount = 0;
    this.receiptPayments.forEach((f) => {
      const controls = this.formGroup.controls;
      if (controls[`receivedmoney${f.Index}`].value > 0) {
        const rp = this.receiptPayments.find((w) => w.Index === f.Index);
        if (this.isDeposit) {
          const rpType = this.ReceiptPaymentType.find((x) => x.Id === rp.ReceiptPaymentTypeId);
          if (rpType.Code === ReceiptPaymentTypeEnum.Receipt) depositAmount += controls[`receivedmoney${f.Index}`].value;
          else depositAmount -= controls[`receivedmoney${f.Index}`].value;
        }
        rp.PaymentMethodId = this.formGroup.controls[`PaymentMethodId${f.Index}`].value;
        rp.ReceiptPaymentTypeId = this.formGroup.controls[`ReceiptPaymentTypeId${f.Index}`].value;
        rp.Amount = this.formGroup.controls[`receivedmoney${f.Index}`].value;
        rp.BranchId = this.order.invoice.BranchId;
        rp.InvoiceId = this.order.invoice.Id;
        const findTitle = this.ReceiptPaymentType.find((x) => x.Id === rp.ReceiptPaymentTypeId);
        rp.ReceiptPaymentTypeTitle = findTitle ? findTitle.Title : null;
        rp.PaymentMethodCode = f.PaymentMethod.find((x) => x.Id === f.PaymentMethodId)?.PaymentMethodCode;
      }
    });
    if (this.isDeposit) {
      this.order.depositFormGroup.controls["DepositAmount"].setValue(depositAmount);
      this.order.depositFormGroup.markAsDirty();
    }
    this.order.invoice.Debit = this.formGroup.controls[`debit`].value ?? 0;
    this.order.invoice.Credit = this.formGroup.controls[`credit`].value ?? 0;
    this.order.invoice.Tip = this.formGroup.controls[`tip`].value ?? 0;
    this.order.invoice.ReceiptPayments = JSON.parse(JSON.stringify(this.receiptPayments.filter((f) => f.Amount > 0)));
  }
  async BeforeSaveCheck(paymentMethodType?: PaymentMethodType) {
    if (this.accountService.authService.currentInformation().HasProtel && this.order.invoice.Customer?.AutomaticDebtor && !this.closeDialog) {
      const roomNumber = this.order.invoice.Customer.Party.LastName;
      this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PleaseWait"));

      this.httpCommonService
        .get(`Invoice/GetProtelData/${roomNumber}`)
        .pipe(take(1))
        .subscribe(
          (data: ProtelModel[]) => {
            this.protel = data[0];

            this.splashFormService.closeLoading();
            let name = this.protel.FullName;
            let reservationNumber = this.protel.ReservationNumber;
            let rmNumber = this.protel.RoomNumber;
            this.sts.showDialog(
              `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Name")}: ${name}
                                  ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.RoomNumber")}: ${rmNumber}
                                  ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ReservationNumber")}: ${reservationNumber}`,
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Attention"),
              DialogType.confirm,
              () => {
                if (this.order.invoice.CustomerPrintCount < 1) {
                  this.order.invoice.Description += `,reservationNumber: ${reservationNumber},`;
                  this.order.invoice.Description += `,roomNumber: ${rmNumber},`;
                  this.order.invoice.Description += `,fullName: ${name},`;
                }
                this.save();
                this.order.newInvoice();
                this.closeDialog = true;
                this.closeModal();
              }
            );
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ConnectToProtel"),
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Attention")
            );
            this.save();
            this.order.newInvoice();
            this.closeDialog = true;
          }
        );
    } else {
      this.save(paymentMethodType);
    }
  }
  async save(paymentMethodType?: PaymentMethodType) {
    this.isFinished++;
    if (this.isFinished > 1 || !this.isValid()) {
      this.isFinished = 0;
      return;
    }
    const localSettings = this.storage.getData(ClearableCache.LocalSetting);
    const selectRow = this.receiptPayments?.find((r) => this.PaymentMethod.find((x) => x.Id === r.PaymentMethodId));
    const localSetting = localSettings.find((x) => x.PaymentMethodId === selectRow.PaymentMethodId);
    if (
      localSetting?.IsWebService &&
      this.receiptPayments?.find((r) => r.PaymentMethodCode === PaymentMethodEnum.Pos && r.State === this.rowState.New)
    ) {
      this.order.splashFormService
        .openDialogwithCancelButton("", this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.WaitForCardDraw"))
        .pipe(take(1))
        .subscribe((flag: any) => {
          if (!flag) {
            const ComputerName = this.storage.getData(ClearableCache.ComputerName);
            this.httpCommonService
              .get(`ReceiptPayment/CancelSamanaPosRequest/${ComputerName}`)
              .pipe(take(1))
              .subscribe((data: PosPaymentResponse) => {
                this.sts.showToast("danger", "", data.Message);
                this.isSaved = false;
                this.submitted = false;
                this.isClosing = false;
                this.isSaving = false;
                this.deactivateClose = false;
                this.deactivateSave = false;
                this.deactiveForm = false;
                this.isFinished = 0;
                this.selectorService.submitted$.next(this.submitted);
              });
          }
        });
    }

    this.beforeSaveData();
    let commandCode = paymentMethodType
      ? InvoiceCommand.PosPayment
      : this.isClearWithoutPrint
      ? InvoiceCommand.ClearWithoutPrint
      : InvoiceCommand.Clear;

    const tabletPosPayment = this.receiptPayments?.find((f) => f.PaymentMethodCode === PaymentMethodType.TabletPos && f.State === RowState.New);
    if ((!paymentMethodType && tabletPosPayment) || paymentMethodType === PaymentMethodType.TabletPos) {
      this.order.invoice.posPaymentIndex = tabletPosPayment.Index;
      commandCode = InvoiceCommand.TabletPos;
    }

    if (this.isDeposit) {
      if (!this.order.invoice.StatusCode) this.order.invoice.StatusCode = InvoiceStatus.Pending;
      commandCode = this.action;
    }
    this.invoiceAction.openFromPaymentForm = true;
    this.invoiceAction.SaveInvoice(commandCode, this.order.invoice);

    if (!this.invoiceAction.saveEndSubscription) {
      this.invoiceAction.saveEndSubscription = this.invoiceAction.saveEnd.subscribe(
        (data) => {
          if (data === true && (this.formGroup.controls[`remaining`].value == 0 || this.formGroup.controls["NonBalance"].value)) {
            this.closeModal();
            this.order.newInvoice();
          } else if (data) {
            this.splashFormService.openDialog(
              "",
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PaymentCompletedLoadingInformation")
            );
            this.invoiceAction.openFromPaymentForm = false;
            this.receiptPayments = data?.ReceiptPayments;
            this.httpCommonService
              .getItem("Invoice/GetInvoiceById", data.Id)
              .pipe(take(1))
              .subscribe(
                (invoice: Invoice) => {
                  this.order.invoice.State = RowState.Modify;
                  invoice.Items.forEach((ele) => {
                    ele.State = RowState.NoChange;
                  });
                  /// Change By Nima Azin For Support Edit Mode With Remain
                  if (
                    this.formGroup.controls[`remaining`].value < 0 &&
                    -this.formGroup.controls[`remaining`].value === invoice.ReceiptPayments[invoice.ReceiptPayments.length - 1].Amount
                  ) {
                    /// Read Reamain and delete it for ready row edit by user input
                    const findItem = Object.assign(
                      {},
                      invoice.ReceiptPayments.find((f) => f.Comment === "1000")
                    );
                    findItem.State = RowState.New;
                    findItem.Id = 0;
                    findItem.Comment = "10001";
                    findItem.RowVersion = null;
                    invoice.ReceiptPayments.push(findItem);
                    invoice.ReceiptPayments.find((f) => f.Comment === "1000").State = RowState.Delete;
                    this.hasAutorecord = true;
                    invoice.Items.map((ele) => {
                      ele.NewQuantity = ele.Quantity;
                    });
                  }
                  /// End
                  /// Get Old Cash User Input And Deleted And push In New State
                  let existReceiptLst: any[] = [];
                  invoice.ReceiptPayments.forEach((ele) => {
                    if (
                      ele.State != this.rowState.Delete &&
                      ele.Id &&
                      this.receiptPayments?.some(
                        (s) =>
                          (s.Id == 0 || !s.Id) &&
                          s.PaymentMethodCode == PaymentMethodType.Cash &&
                          s.State != this.rowState.Modify &&
                          s.State != this.rowState.Delete &&
                          s.ReceiptPaymentTypeId === ele.ReceiptPaymentTypeId &&
                          s.PaymentMethodId === ele.PaymentMethodId &&
                          s.Amount === ele.Amount
                      )
                    ) {
                      const newRow = Object.assign({}, ele);
                      newRow.Id = 0;
                      newRow.State = this.rowState.New;
                      existReceiptLst.push(newRow);
                      ele.State = this.rowState.Delete;
                    }
                  });
                  if (existReceiptLst?.length > 0) {
                    existReceiptLst.forEach((ele) => {
                      invoice.ReceiptPayments.push(Object.assign({}, ele));
                    });
                  }
                  /// End

                  this.order.invoice.Items = invoice.Items;
                  this.order.invoice.NumberingInDate = invoice.NumberingInDate;
                  this.order.invoice.Id = invoice.Id;
                  this.order.invoice.RowVersion = invoice.RowVersion;
                  this.order.invoice.CreatedUserId = invoice.CreatedUserId;
                  this.order.invoice.ModifiedDate = invoice.ModifiedDate;
                  this.order.invoice.CreateDateTime = invoice.CreateDateTime;
                  this.order.invoice.CreatedDate = invoice.CreatedDate;
                  this.order.invoice.CreatedUserName = invoice.CreatedUserName;
                  this.order.invoice.ModifiedDateTime = invoice.ModifiedDateTime;
                  this.order.invoice.ModifiedUserId = invoice.ModifiedUserId;

                  //  const invalidList  = invoice.ReceiptPayments.filter(f=>f.State == this.rowState.Delete && f.Id == 0);
                  //  if(invalidList == null && invalidList?.length > 0) {
                  //   invalidList.forEach(element => {
                  //     invoice.ReceiptPayments = invoice.ReceiptPayments.filter(f=>f !== element);
                  //   });
                  //  }
                  this.receiptPayments = Object.assign([], invoice.ReceiptPayments);
                  this.order.invoice.ReceiptPayments = Object.assign([], invoice.ReceiptPayments);

                  for (let i = 0; i < this.receiptPayments?.length; i++) {
                    const index = Math.floor(Math.random() * 10000000);
                    this.receiptPayments[i].ReceiptPaymentType = JSON.parse(JSON.stringify(this.ReceiptPaymentType));
                    this.receiptPayments[i].PaymentMethod = JSON.parse(JSON.stringify(this.PaymentMethod));
                    this.receiptPayments[i].Index = index;
                    if (this.order.invoice.ReceiptPayments && this.order.invoice.ReceiptPayments.length > 0) {
                      this.setValue(`PaymentMethodId${index}`, this.receiptPayments[i].PaymentMethodId, true);
                      this.setValue(`ReceiptPaymentTypeId${index}`, this.receiptPayments[i].ReceiptPaymentTypeId, true);
                      this.setValue(`receivedmoney${index}`, this.receiptPayments[i].Amount, true);
                      if (invoice.ReceiptPayments[i].Id !== 0 && invoice.ReceiptPayments[i].Id) {
                        if (
                          this.receiptPayments[i].PaymentMethodCode === PaymentMethodType.Pos ||
                          this.receiptPayments[i].PaymentMethodCode === PaymentMethodType.TabletPos
                        ) {
                          this.receiptPayments[i].State = RowState.Modify;
                        }
                        this.receiptPayments[i].Id = invoice.ReceiptPayments[i].Id;
                        this.receiptPayments[i].Comment = invoice.ReceiptPayments[i].Comment;
                        if (this.receiptPayments[i].State !== RowState.New) {
                          this.formGroup.controls[`PaymentMethodId${index}`].disable();
                          this.formGroup.controls[`receivedmoney${index}`].disable();
                          this.formGroup.controls[`ReceiptPaymentTypeId${index}`].disable();
                        }
                      }
                    }
                  }
                  if (
                    this.formGroup.controls[`remaining`].value === 0 &&
                    commandCode === InvoiceCommand.PosPayment &&
                    data.ReceiptPayments.length === invoice.ReceiptPayments.length &&
                    !invoice.ReceiptPayments.some((s) => s.Comment === "1000") &&
                    !this.savePaymentClicked
                  ) {
                    this.invoiceAction.SaveInvoice(InvoiceCommand.Clear, invoice, null, this.order);
                    this.invoiceAction.isStartAction = 0;
                  }

                  if (
                    this.formGroup.controls[`remaining`].value === 0 &&
                    commandCode === InvoiceCommand.TabletPos &&
                    data.ReceiptPayments.length === invoice.ReceiptPayments.length
                  ) {
                    this.invoiceAction.SaveInvoice(InvoiceCommand.Clear, invoice, null, this.order);
                    this.invoiceAction.isStartAction = 0;
                  }

                  this.cd.markForCheck();
                  if (!this.receiptPayments?.some((s) => s.Comment == null))
                    this.receiptPayments = this.receiptPayments?.sort((a, b) => Number(a.Comment) - Number(b.Comment));
                  this.calculate();
                  if (this.savePaymentClicked) {
                    setTimeout(() => {
                      this.deactivateSave = false;
                      this.deactivateClose = false;
                      this.isSaved = false;
                      this.isSaving = false;
                      this.isFinished = 0;
                    }, 10);
                  }
                  this.cd.markForCheck();
                  this.splashFormService.closeLoading();
                },
                (error) => {
                  this.sts.showToast("danger", "", `${Utilities.getHttpResponseMessage(error)}`);
                  this.selectorService.submitted$.next(this.submitted);
                  this.splashFormService.closeLoading();
                }
              );
          } else {
            this.invoiceAction.openFromPaymentForm = false;
            this.isSaved = false;
            this.isSaving = false;
            this.selectorService.submitted$.next(this.submitted);
            this.calculate();
          }
          this.isFinished = 0;
        },
        (error) => {
          this.isSaved = false;
          this.isSaving = false;
          this.isFinished = 0;
          this.calculate();
          this.sts.showToast("danger", "", `${Utilities.getHttpResponseMessage(error)}`);
          this.selectorService.submitted$.next(this.submitted);
          this.splashFormService.closeLoading();
        }
      );
    }

    this.invoiceAction.ActionFinish.pipe(take(1)).subscribe((result) => {
      this.isSaved = false;
      this.submitted = false;
      this.isClosing = false;
      this.isSaving = false;
      this.deactivateClose = false;
      this.deactivateSave = false;
      this.deactiveForm = false;
      this.isFinished = 0;
      this.selectorService.submitted$.next(this.submitted);
    });
  }
  closeForm() {
    this.sts.showToast("info", "", this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.SavingChanges"));
    this.isSaving = false;
    this.isSaved = false;
    this.isClosing = false;
    this.submitted = true;
    this.hasChange();
    this.sts.showToast(
      "success",
      this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Successful"),
      `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.InformationChanges")}  ${this.label}  ${this.translate(
        "ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.SavedSuccessfully"
      )} `
    );
    this.result = true;
    this.closeModal();
  }
  hasChange() {
    if (!this.order.invoice.ReceiptPayments || this.order.invoice.ReceiptPayments.length <= 0) return;
    else {
      for (let i = 0; i < this.receiptPayments?.length; i++) {
        const findPayment = this.order.invoice.ReceiptPayments.find((f) => f.Id === this.receiptPayments[i].Id);
        if (findPayment && this.receiptPayments[i] !== findPayment) {
          this.receiptPayments[i].State = RowState.Modify;
        }
      }
    }
  }
  checkIsPosPayment(model: any, index: number) {
    let posOrTabletPos = this.PaymentMethod?.filter(
      (c) => c.PaymentMethodCode == PaymentMethodEnum.Pos || c.PaymentMethodCode == PaymentMethodEnum.TabletPos
    ).map((c) => c.Id);
    let posOrTabletPosReciptPayment = this.receiptPayments?.filter((c) => posOrTabletPos.includes(c.PaymentMethodId) && c.State === RowState.New);
    if (posOrTabletPosReciptPayment && posOrTabletPosReciptPayment?.length > 1) {
      this.setValue(`PaymentMethodId${index}`, null);
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PaymentByMethodNotPossible")}`,
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ErrorMessage")
      );
    }
    const receiptPayment = this.receiptPayments?.find((x) => x.Index === index);
    const receiptPaymentType = this.receiptPayments[0].ReceiptPaymentType.find(
      (f) => f.Id === this.formGroup.controls[`ReceiptPaymentTypeId${index}`].value
    ).Code;
    const paymentMethod = this.receiptPayments[0].PaymentMethod.find(
      (f) => f.Id === this.formGroup.controls[`PaymentMethodId${index}`].value
    ).PaymentMethodCode;
    if (receiptPaymentType === ReceiptPaymentTypeEnum.Payment && paymentMethod === PaymentMethodEnum.Pos) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PaymentByMethodNotPossible")}`,
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ErrorMessage")
      );
      this.setValue(`PaymentMethodId${index}`, null);
    }
    if (model.Category !== "ReceiptPaymentType") {
      const receiptPaymentType = receiptPayment?.ReceiptPaymentType.find((f) => f.Id === receiptPayment?.ReceiptPaymentTypeId).Code;
      if ((model.PaymentMethodCode === PaymentMethodEnum.Pos || model.PaymentMethodCode === PaymentMethodEnum.TabletPos) && receiptPaymentType === 2)
        this.receiptPayments.find((w) => w.Index === index).ShowPospayment = true;
      else this.receiptPayments.find((w) => w.Index === index).ShowPospayment = false;
    } else {
      if (model.Code !== 2) this.receiptPayments.find((w) => w.Index === index).ShowPospayment = false;
      else {
        const PaymentType = receiptPayment?.PaymentMethod.find((f) => f.Id === receiptPayment?.PaymentMethodId).PaymentMethodCode;
        if (PaymentType === PaymentMethodEnum.Pos || PaymentType === PaymentMethodEnum.TabletPos)
          this.receiptPayments.find((w) => w.Index === index).ShowPospayment = true;
      }
    }
    this.checkValidation();
  }
  calculate(isFirst?: boolean) {
    let remain = 0;
    if (this.formGroup.controls[`remaining`].value < 0 && this.formGroup.controls[`credit`].value) {
      this.setValue("credit", null);
      this.setValue("tip", null);
      this.hasCreditTransfer = false;
      this.hasTipTransfer = false;
    }
    if (this.formGroup.controls[`remaining`].value > 0 && this.formGroup.controls[`debit`].value) {
      this.setValue("debit", null);
      this.hasDebitTransfer = false;
    }
    const debit = this.formGroup.controls[`debit`].value ? this.formGroup.controls[`debit`].value : 0;
    const credit = this.formGroup.controls[`credit`].value ? this.formGroup.controls[`credit`].value : 0;
    const tip = this.formGroup.controls[`tip`].value ? this.formGroup.controls[`tip`].value : 0;
    if (this.receiptPayments?.length && this.receiptPayments?.length > 0) {
      this.receiptPayments
        .filter((f) => f.State !== RowState.Delete)
        .forEach((f) => {
          if (
            this.formGroup.controls[`ReceiptPaymentTypeId${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value &&
            this.formGroup.controls[`receivedmoney${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value
          ) {
            if (
              this.ReceiptPaymentType?.find((f) => f.Code === 2)?.Id ===
              this.formGroup.controls[`ReceiptPaymentTypeId${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value
            )
              remain += Number(this.formGroup.controls[`receivedmoney${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value);
            else {
              remain -= Number(this.formGroup.controls[`receivedmoney${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value);
            }
          }
          this.receiptPayments.find((w) => w.Index === f.Index).Amount = Number(
            this.formGroup.controls[`receivedmoney${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value
          );
          this.receiptPayments.find((w) => w.Index === f.Index).ReceiptPaymentTypeId = Number(
            this.formGroup.controls[`ReceiptPaymentTypeId${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value
          );
          this.receiptPayments.find((w) => w.Index === f.Index).PaymentMethodId = Number(
            this.formGroup.controls[`PaymentMethodId${this.receiptPayments.find((w) => w.Index === f.Index).Index}`].value
          );
        });
      this.formGroup.controls[`remaining`].setValue(remain - Number(tip) - Number(credit) + Number(debit) - this.order.invoice.PayableTotal);
    } else {
      if (!this.formGroup.controls[`debit`].value || this.formGroup.controls[`debit`].value === 0)
        this.formGroup.controls[`remaining`].setValue(-this.order.invoice.PayableTotal);
    }
    if ((this.formGroup.controls[`remaining`].value > 0 || this.formGroup.controls[`tip`].value) && this.receiptPayments.length > 0)
      this.hasTipTransfer = true;
    else {
      this.hasTipTransfer = false;
      this.setValue("tip", null);
    }
    if ((this.formGroup.controls[`remaining`].value > 0 || this.formGroup.controls[`credit`].value) && this.order.invoice.Customer?.HasCredit)
      this.hasCreditTransfer = true;
    else this.hasCreditTransfer = false;
    if (
      (this.formGroup.controls[`remaining`].value < 0 || isFirst || this.formGroup.controls[`debit`].value) &&
      this.order.invoice.Customer?.HasCredit
    )
      this.hasDebitTransfer = true;
    else this.hasDebitTransfer = false;
    if (this.formGroup.controls[`remaining`].value === 0) this.deactivateSave = false;
    else if (!this.formGroup.controls["NonBalance"].value) {
      this.deactivateSave = true;
    }
    if (this.formGroup.controls[`remaining`].value < 0 || this.formGroup.controls[`debit`].value) {
      this.setValue("credit", null);
      this.hasCreditTransfer = false;
    }
    if (this.formGroup.controls[`remaining`].value > 0 || this.formGroup.controls[`credit`].value) {
      this.setValue("debit", null);
      this.hasDebitTransfer = false;
    }
    this.checkValidation();
  }
  // فعال کردن دکنه تسویه
  checkValidation() {
    if (this.formGroup.controls["NonBalance"]?.value) {
      this.deactivateSave = false;
      return;
    }
    if (
      this.receiptPayments?.some((s) => !s.PaymentMethodId) ||
      this.receiptPayments?.some((s) => !s.ReceiptPaymentTypeId) ||
      this.formGroup.controls[`remaining`].value !== 0 ||
      !this.receiptPayments ||
      (this.receiptPayments.length === 0 &&
        (!this.formGroup.controls[`debit`].value || this.formGroup.controls[`debit`].value === 0) &&
        this.formGroup.controls[`remaining`].value > 0)
    ) {
      this.deactivateSave = true;
      return;
    }
    if (this.receiptPayments?.filter((s) => s.ShowPospayment)?.length > 1) {
      this.deactivateSave = true;
      return;
    }
    if (!this.receiptPayments?.some((s) => s.State === RowState.New) && !this.isDeposit) {
      this.deactivateSave = true;
      return;
    }
    if (this.order.invoice.Customer?.HasCredit) this.deactivateSave = false;
    else {
      this.deactivateSave = true;
    }
    this.deactivateSave = false;
  }

  // انتقال باقیمانده
  transfer(value: PaymentEnum) {
    switch (value) {
      case PaymentEnum.Debit:
        if (this.formGroup.controls[`remaining`].value >= 0) {
          return;
        }
        if (this.formGroup.controls["NonBalance"].value) {
          this.sts.showDialog(
            `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.ActivationOptionReceiveBalanceByCourier")}`,
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Attention"),
            DialogType.alert
          );
          return;
        }
        this.formGroup.controls[`debit`].setValue(-this.formGroup.controls[`remaining`].value + Number(this.formGroup.controls["debit"].value));
        this.setValue("remaining", 0);
        this.calculate();
        break;
      case PaymentEnum.Credit:
        if (this.formGroup.controls[`remaining`].value <= 0) {
          return;
        }
        this.formGroup.controls[`credit`].setValue(this.formGroup.controls[`remaining`].value + Number(this.formGroup.controls["credit"].value));
        this.setValue("remaining", 0);
        this.calculate();
        break;
      case PaymentEnum.Tip:
        if (this.formGroup.controls[`remaining`].value <= 0) {
          return;
        }
        this.formGroup.controls[`tip`].setValue(this.formGroup.controls[`remaining`].value + Number(this.formGroup.controls["tip"].value));
        this.setValue("remaining", 0);
        this.calculate();
        this.deactivateSave = false;
        break;
    }
  }
  /// حذف ورودی ها
  clear(value: PaymentEnum) {
    switch (value) {
      case PaymentEnum.Debit:
        this.formGroup.controls[`debit`].setValue(null);
        this.calculate();
        break;
      case PaymentEnum.Credit:
        this.formGroup.controls[`credit`].setValue(null);
        this.calculate();
        break;
      case PaymentEnum.Tip:
        this.formGroup.controls[`tip`].setValue(null);
        this.calculate();
        break;
    }
  }
  Payment(Index: number) {
    this.savePaymentClicked = true;
    if (!this.formGroup.valid) {
      this.sts.showToast("danger", "", `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.EnterFormValues")}`);
      return;
    }
    const findPayment = this.receiptPayments?.find((f) => f.Index === Index);
    const localSettings = this.storage.getData(ClearableCache.LocalSetting);
    const localSetting = localSettings.find((x) => x.PaymentMethodId === findPayment.PaymentMethodId);
    if (!localSetting?.IsWebService) {
      this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.WaitForCardDraw"));
    } else {
      this.order.splashFormService
        .openDialogwithCancelButton("", this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.WaitForCardDraw"))
        .subscribe((flag: any) => {
          if (!flag) {
            const ComputerName = this.storage.getData(ClearableCache.ComputerName);
            this.httpCommonService
              .get(`ReceiptPayment/CancelSamanaPosRequest/${ComputerName}`)
              .pipe(take(1))
              .subscribe(
                (data: any) => {
                  if (data.IsSuccess)
                    this.sts.showToast(
                      "danger",
                      "",
                      `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PaymentCanceledSuccessfully")}`
                    );
                  else {
                    this.sts.showToast("danger", "", `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.CancellationFailed")}`);
                  }
                },
                (error) => {
                  this.sts.showToast("danger", "", `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.CancellationFailed")}`);
                }
              );
          }
        });
    }
    this.order.invoice.posPaymentIndex = Index;
    const findPaymentCode = findPayment?.PaymentMethod?.find((f) => f.Id === findPayment.PaymentMethodId)?.PaymentMethodCode;
    if (findPaymentCode === PaymentMethodType.Pos || findPaymentCode === PaymentMethodType.TabletPos) {
      this.save(findPaymentCode);
    } else this.save();
  }
  /// چک کردن ورودی ها
  changeInputValue(kind?: PaymentEnum, value?: string) {
    switch (kind) {
      case PaymentEnum.Debit:
        if (this.formGroup.controls[`debit`].value === 0) {
          this.setValue("debit", null);
          return;
        }
        if (this.formGroup.controls[`remaining`].value > 0) {
          this.setValue("debit", null);
          return;
        }
        if (-this.formGroup.controls[`remaining`].value < Number(value)) {
          this.clear(kind);
          this.transfer(kind);
          return;
        }
        break;
      case PaymentEnum.Credit:
        if (this.formGroup.controls[`credit`].value === 0) {
          this.setValue("credit", null);
          return;
        }
        if (this.formGroup.controls[`remaining`].value < 0) {
          this.setValue("credit", null);
          return;
        }
        if (this.formGroup.controls[`remaining`].value < Number(value)) {
          this.clear(kind);
          this.transfer(kind);
          return;
        }
        break;
      case PaymentEnum.Tip:
        if (this.formGroup.controls[`tip`].value === 0) {
          this.setValue("tip", null);
          return;
        }
        if (this.formGroup.controls[`remaining`].value < Number(value)) {
          this.clear(kind);
          this.transfer(kind);
          return;
        }
        break;
    }
    this.calculate();
  }

  nonBalanceValidation() {
    const controls = this.formGroup.controls;
    if ((controls[`remaining`].value > 0 || controls["credit"].value || controls["debit"].value) && !this.nonBalanceChangedManualy) {
      this.nonBalanceChangedManualy = true;
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.PossibleToSelectReceiveRemainingByCourier")}`,
        `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Invoice.Payment.Attention")}`,
        DialogType.alert
      );
      this.setValue("NonBalance", false);
      this.model.NonBalance = false;
      return;
    }
    this.nonBalanceChangedManualy = false;
    this.checkValidation();
  }
}
